// Mobile footer accordion (progressive enhancement).
// Base state, if this script never runs (blocked, slow, error): the footer
// stays exactly as it already is today — fully expanded, flat, fully usable.
// This script only ever ADDS a collapsed/expandable state; it never assumes
// collapsed as the default, so a JS failure can't hide any footer links.
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) {
    return;
  }

  var footerGroups = document.querySelectorAll('.footer .menus__item');

  footerGroups.forEach(function (item) {
    var heading = item.querySelector(':scope > .menus__item-title');
    var panel = item.querySelector(':scope > .menu-container--footer');
    if (!heading || !panel) return;

    panel.style.display = 'none';
    heading.classList.add('footer-accordion-toggle');
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');

    function toggle() {
      var isOpen = panel.style.display !== 'none';
      panel.style.display = isOpen ? 'none' : 'block';
      heading.setAttribute('aria-expanded', String(!isOpen));
      item.classList.toggle('is-open', !isOpen);
    }

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
});
